export default  {"src":"/_next/static/image/public/images/icon_sm_invoice.da81da99024034e1a480b9ad1c57bbf3.svg","height":21,"width":16};